
import Vue from "vue";
export default Vue.extend({
	props: {
		disabled: Boolean
	},
	methods: {
		onClick(event:Event){
			this.$emit("click", event);
		}
	}
});
